import { registerReducer } from 'foremanReact/common/MountingService';
import rootReducer from '../redux/reducers';

export default () =>
  registerReducer('foremanRemoteExecutionReducers', rootReducer);



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_remote_execution-8.0.0-2.fm3_4.el8.noarch/usr/share/gems/gems/foreman_remote_execution-8.0.0/webpack/react_app/extend/reducers.js